import React from 'react';
import { compose } from 'ramda';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { defaultProps, withHandlers } from 'recompose';

import CrownIcon from 'app/features/migration/landing/components/SignupCta/CrownIcon';
import Styled from 'app/features/migration/landing/components/SignupCta/SignupCta.styled';
import Button from 'app/components/Button/Button';
import {
  FAN_PACK_FREE_TRIAL_SKU,
  LENGTH_OF_MIGRATION_FREE_TRIAL,
} from 'app/constants/freeTrial';
import { isLoading, parsedCoupon } from 'app/features/couponCampaign/selectors';
import { ctaLink } from 'app/features/migration/landing/components/SignupCta/selectors';
import {
  couponSelected,
  startCouponFlow,
} from 'app/features/couponCampaign/actions';
import { productCtaClicked } from 'app/features/landing/actions';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import connect from 'app/libs/connect';
import { TOP } from 'app/analytics/constants/positions';

const UI = props => (
  <Styled.ButtonHolder>
    <Button {...props}>
      <Styled.ButtonContent>
        <CrownIcon />
        <FormattedMessage id="migration_signup_cta_title" />
      </Styled.ButtonContent>
    </Button>
  </Styled.ButtonHolder>
);

UI.propTypes = {
  onClick: PropTypes.func.isRequired,
};

UI.displayName = 'SignupCta';

const defaults = {
  type: 'six',
  position: TOP,
  isWideOnMobile: true,
  sku: FAN_PACK_FREE_TRIAL_SKU,
  testId: 'migration_landing_cta',
  textKey: 'migration_signup_cta_title',
  lengthOfFreeTrial: LENGTH_OF_MIGRATION_FREE_TRIAL,
};

const state = { parsedCoupon, isLoading, to: ctaLink };

const actions = { couponSelected, productCtaClicked, startCouponFlow };

const onClick =
  ({ couponSelected, parsedCoupon, productCtaClicked, ...restProps }) =>
  () => {
    couponSelected(parsedCoupon);
    productCtaClicked(restProps);
  };

const SignupCta = compose(
  defaultProps(defaults),
  withDispatchOnMount(compose(startCouponFlow)),
  connect(state, actions),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default SignupCta;
